import React, { useState } from 'react'
import validator from 'validator';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import { SURVEYURL } from '../Apiurl';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const LiveSurvey = ({type}) => {
  const [email, setEmail] = useState('');
  const [otp, sentOtp] = useState('');
  const navigate = useNavigate()
  const params = useParams()

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [guestLoad, setGuestLoad] = useState(false);

  const [otpSent, setOtpSent] = useState(false)
  const handleSubmit = async (e) => {
    e.preventDefault();
    // setIsSubmitting(true);
    if (!otpSent) {
      if (validator.isEmail(email)) {
        setIsSubmitting(true);
        const { data } = await axios.post(`${SURVEYURL}/email/verification/otp/sent`, { email: email?.toLowerCase()?.trim(), key: params?.key })
        if (data?.success) {
          toast.success("OTP Sent Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          })
          localStorage.removeItem("userDetails")
          setIsSubmitting(false)
          setOtpSent(true)
        } else {
          if (data?.status == 1) {
            navigate("/survey/thank-you")
          } else {
            if (data?.status == 2) {
              toast.success("Inactive Survey", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
              })
              localStorage.removeItem("userDetails")
              setIsSubmitting(false)
              setOtpSent(false)
            } else {
              // alert("Live")
              localStorage.setItem("userDetails", JSON.stringify(data?.data))
              navigate(`/survey/start/${params?.key}`)
            }

          }
          // setIsSubmitting(false)
        }
      } else {
        toast.error("Enter Valid Email", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        })
      }
    } else {
      const { data } = await axios.post(`${SURVEYURL}/email/verification/otp/verify`, { email: email?.toLowerCase()?.trim(), otp, key: params?.key })
      if (data?.success) {
        toast.success(data?.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        })
        setIsSubmitting(false)
        // alert("Live")
        localStorage.setItem("userDetails", JSON.stringify(data?.data))
        navigate(`/survey/start/${params?.key}`)
        // setIsSubmitting(false)
        // setOtpSent(true)
      } else {
        toast.error("Invalid OTP", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        })
        setIsSubmitting(false)
      }
    }
  };

  const joinSurveyAsGuestUser = async () => {
    try {
      setGuestLoad(true)
      const guestUserDetails = JSON.parse(localStorage.getItem("guestUserDetails"))
      const { data } = await axios.post(`${SURVEYURL}/join-survey-as-guest-user/join`, { key: params?.key, id: guestUserDetails ? guestUserDetails?.id : undefined })
      if (data?.success) {
        toast.success(data?.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        })
        setGuestLoad(false)
        // alert("Live")
        localStorage.setItem("userDetails", JSON.stringify(data?.data))
        localStorage.setItem("guestUserDetails", JSON.stringify(data?.data))
        navigate(`/survey/start/${params?.key}`)
        // setIsSubmitting(false)
        // setOtpSent(true)
      } else {
        toast.error(data?.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        })
        setGuestLoad(false)
      }
    } catch (err) {
      setGuestLoad(false)
    }
  }
  return (
    <div className="card survey-card">
      <div className="card-body">
        <h1 className="card-title">Join Survey</h1>
        <form onSubmit={handleSubmit}>
          {type=="Survey" && <>
          <div className="mb-4">
            {!otpSent ? <input
              type="email"
              className="form-control"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isSubmitting}
            /> : <input
              type="text"
              className="form-control"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => sentOtp(e.target.value)}
              required
              disabled={isSubmitting}
            />}
          </div>
          {!otpSent ? <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Please Wait...
              </>
            ) : (
              'Request OTP'
            )}
          </button> : <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Please Wait...
              </>
            ) : (
              'Verify OTP'
            )}
          </button>}
          </>}

          {type=="Anonymous Survey" && <button
            className="btn btn-primary-guest w-100 fs-6"
            disabled={guestLoad}
            onClick={() => {
              joinSurveyAsGuestUser()
            }}
          >
            {guestLoad ? (
              <>
                <span className="spinner-border spinner-border-sm me-2 text-white" role="status" aria-hidden="true"></span>
                Please Wait...
              </>
            ) : (
              'Play as Guest User'
            )}
          </button>}


        </form>
      </div>
    </div>
  )
}

export default LiveSurvey
